import { createFileRoute, redirect } from '@tanstack/react-router'
import { createServerFn } from '@tanstack/react-start'
import { getRequest } from '@tanstack/react-start/server'
import { LandingPage } from '#/components/landing/landing-page'
import { m } from '#/paraglide/messages'

/** Signed-in visitors skip the marketing page and land on the workspace home (plane.so → app.plane.so). */
const isSignedIn = createServerFn({ method: 'GET' }).handler(async () => {
  const { getSessionFromRequest } = await import('#/lib/session.server')
  const s = await getSessionFromRequest(getRequest()).catch(() => null)
  return Boolean(s?.user)
})

export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    if (await isSignedIn()) throw redirect({ to: '/home' })
  },
  head: () => ({
    meta: [
      { title: m.mk_meta_title() },
      { name: 'description', content: m.mk_meta_desc() },
      { property: 'og:title', content: m.mk_meta_title() },
      { property: 'og:description', content: m.mk_meta_desc() },
      { property: 'og:type', content: 'website' },
      { property: 'og:image', content: '/landing/og.png' },
    ],
  }),
  component: LandingPage,
})
